
  export default {
    name: 'SectionSeoContent',
    components: {
      SeoContentLinkList: () => import('@/components/SeoContentLinkList'),
      SeoContentTeaseredAndRelatedArticlesList: () =>
        import(
          '@/components/elements/SeoContentTeaseredAndRelatedArticlesList'
        ),
      RichText: () => import('@/components/elements/RichText'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey: function (props) {
      return 'section-seo-content-' + props.section.id;
    },
    data() {
      return {
        seoContent: {},
        dynamicSeoContent: null,
      };
    },
    // warum auch immer: wenn das hier ein fetch ist funktioniert es nicht!
    async created() {
      this.seoContent = this.section.seoContent;
    },
  };
